import { render, staticRenderFns } from "./LegoControlCardChat.vue?vue&type=template&id=ddb97c30&scoped=true"
import script from "./LegoControlCardChat.vue?vue&type=script&lang=js"
export * from "./LegoControlCardChat.vue?vue&type=script&lang=js"
import style0 from "./LegoControlCardChat.vue?vue&type=style&index=0&id=ddb97c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb97c30",
  null
  
)

export default component.exports